<template>
  <div class='select_game'>
    <van-popup v-model="selectGame" position="bottom" round :close-on-click-overlay="false">
      <div class="popup_box">
        <div class="popup_title">
          {{ $t('selectGame') }}
        </div>
        <!-- <div class="current_game">
          <img :src="`${regionCdn}assets/img/appkeyIcon/icon_${currentGameUserInfo.appKey}.png`" alt="">
          <div class="info_text">
            <span class="game_name">{{ currentGameUserInfo.name }}</span>
            <span class="game_desc">{{ currentGameUserInfo.description }}</span>
          </div>
        </div> -->
        <div class="game_list">
          <div class="game_item" v-for="(item, index) in gameList" :key="index" @click="SelectGameBtn(item)">
            <div class="game_item_box">
              <img :src="`${regionCdn}assets/img/appkeyIcon/icon_${item.appKey}.png`" alt="">
              <span class="game_name">{{ item.name }}</span>
            </div>
            <div class="change_i"></div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { systemShareLogin } from '@/api'
import { Popup, Toast, Dialog } from 'vant';
import { mapState } from 'vuex'
export default {
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      selectGame: false,//切换游戏弹窗
    };
  },
  computed: {
    ...mapState(['gameList', 'currentGameAppkey', 'regionCdn', 'loginStatus', 'inGame']),
    currentGameUserInfo() {
      //未登录时默认龙魂旅人
      return this.gameList.find(item => item.appKey == this.currentGameAppkey) || {
        name: '龙魂旅人',
        description: '超解压的喜剧后宫番手游',
        appKey: 1656417299063
      }
    }
  },
  watch: {},
  methods: {
    openSelectGame() {
      this.selectGame = true
    },
    getSelectGamePop() {
      if (!this.loginStatus) {
        Toast.fail(this.$t('pleaseLogin'))
        return
      }
      this.selectGame = true
    },
    SelectGameBtn(item) {
      this.$store.commit('changeCurrentGameAppkey', item.appKey)
      this.selectGame = false
      this.$eventBus.$emit('refreshLogin', 'selectGame')
      let userGameList = JSON.parse(localStorage.getItem('zlVipUserList'))
      let game = userGameList.find(item => item.appkey == this.currentGameAppkey)
      if (!game) {//userlist中不含当前游戏，则刷新userlist二次确认
        //刷新userlist列表
        let params = {}
        let userList = JSON.parse(localStorage.getItem('zlVipUserList'))
        let timestamp = parseInt(+new Date() / 1000)
        let pdsign = this.$md5(timestamp + this.$md5(localStorage.getItem('zlVipAccountId') + userList[0].appkey.toString()).toLowerCase() + userList[0].userid + 'Bejz1R1WE3rUhJUf').toLowerCase()
        params = {
          pdseq: localStorage.getItem('zlVipSignature') || '',//防止用户未刷新页面,签名不存在
          token: userList[0].token,
          timestamp: timestamp,
          pdsign: pdsign
        }
        systemShareLogin(params).then(res => {
          if (res.data.info == 10118308) {
            let currentGameUserInfo = res.data.data.userlist.find(item => item.appkey == this.currentGameAppkey)
            if (currentGameUserInfo) {//存在则刷新页面
              localStorage.clear()
              localStorage.setItem('zlVipAccountId', res.data.data.accountid)
              localStorage.setItem('zlVipUserList', JSON.stringify(res.data.data.userlist))
              localStorage.setItem('zlVipSignature', res.data.data.signature)
              localStorage.setItem('zlVipExpire', res.data.data.expire)
              location.reload()
            }
          } else {
            Dialog.alert({
              message: this.$t('refreshProjectListError'),
              confirmButtonText: this.$t('confirm')
            }).then(() => { });
          }
        })
      }
    }
  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='less' scoped>
.select_game {
  z-index: 4;
  margin-top: 1.68rem;
}

.game_info_box {
  width: 5.76rem;
  height: 1.2rem;
  background: #FFFFFF;
  border-radius: .16rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: .16rem;
  padding-right: .32rem;
  box-sizing: border-box;
  box-shadow: 0 0 .2rem .02rem rgba(251, 234, 234, 0.9);

  .game_info {
    display: flex;
    align-items: center;

    img {
      width: .88rem;
      height: .88rem;
      margin-right: .24rem;
    }

    .info_text {
      display: flex;
      flex-direction: column;

      .game_name {
        font-weight: bold;
        font-size: .28rem;
        color: @theme-default-black;
      }

      .game_desc {
        font-size: .2rem;
        color: @theme-default-grey;
      }
    }
  }

  .change_i {
    width: .31rem;
    height: .24rem;
    background: url('@/assets/img/m/public/gift/change_i.png');
    background-size: 100% 100%;
    cursor: pointer;
  }
}

.popup_box {
  .current_game {
    width: 100%;
    padding: 0 .48rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-top: .21rem;

    img {
      width: .88rem;
      height: .88rem;
      margin-right: .24rem;
    }

    .info_text {
      display: flex;
      flex-direction: column;

      .game_name {
        font-weight: bold;
        font-size: .28rem;
        color: @theme-default-black;
      }

      .game_desc {
        font-size: .2rem;
        color: @theme-default-grey;
      }
    }
  }

  .game_list {
    max-height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    margin-top: .16rem;
    padding: 0 .16rem;

    .game_item {
      flex-shrink: 0;
      width: 6.56rem;
      height: 1.04rem;
      background: #F9F9F9;
      border-radius: .16rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .24rem;
      box-sizing: border-box;
      margin-bottom: .16rem;

      .game_item_box {
        display: flex;
        align-items: center;

        img {
          width: .56rem;
          height: .56rem;
          margin-right: .16rem;
        }

        span {
          font-weight: 400;
          font-size: .22rem;
          color: @theme-default-black;
        }
      }

      .change_i {
        width: .31rem;
        height: .24rem;
        background: url('@/assets/img/m/public/gift/change_i.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>